import { CustomFormFieldBase } from "./custom-form-field.type";

export class ImageUploadFormControl extends CustomFormFieldBase<string> {
    override controlType = 'image_upload';
}
